// extracted by mini-css-extract-plugin
export default {"control":"control_control__Nfn-y","disabled":"control_disabled__0qgcv","button":"control_button__1l2R5"};